import { styled as styling } from "@mui/material/styles";

// Grid Components //
export const Wrapper = styling("div")((props) => ({
  paddingTop: "0px",
  //

  [props.theme.breakpoints.down("lg")]: {
    marginTop: "-10px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    marginTop: "0px",
  },
}));
